module.exports = "pegasus/assets/website-announcement-background.png";